// extracted by mini-css-extract-plugin
module.exports = {"faq__Container":"Faq_faq__Container__2YY1s","accordion__Container":"Faq_accordion__Container__3_CtX","faq__Text":"Faq_faq__Text__1Qf7b","faq_underline":"Faq_faq_underline__GkOHE"};